import { nextStateHistory, StateHistory } from 'aurelia-store';
import cloneDeep from 'lodash-es/cloneDeep';

import { AppState } from '~/app-store';

const LoginUser = (stateHistory: StateHistory<AppState>) => {
	const newState: AppState = cloneDeep(stateHistory.present);
	newState.isLoggedIn = true;
	return nextStateHistory<AppState>(stateHistory, newState);
};

export const LoginActions = {
	LoginUser,
};
